'use strict';

exports.__esModule = true;
// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var GOOGLE_MAP_LOADED = exports.GOOGLE_MAP_LOADED = 'SEARCH_ACTIONS:GOOGLE_MAP_LOADED';
var PAGE_LOADED = exports.PAGE_LOADED = 'SEARCH_ACTIONS:PAGE_LOADED';
var SEARCH_BAR_HOLDER_HEIGHT_UPDATE = exports.SEARCH_BAR_HOLDER_HEIGHT_UPDATE = 'SEARCH_ACTIONS:SEARCH_BAR_HOLDER_HEIGHT_UPDATE';
var INSURERS_DROPDOWN_ELEM_UPDATE = exports.INSURERS_DROPDOWN_ELEM_UPDATE = 'SEARCH_ACTIONS:INSURERS_DROPDOWN_ELEM_UPDATE';
var INSURERS_SEARCH_ITEM_ELEM_UPDATE = exports.INSURERS_SEARCH_ITEM_ELEM_UPDATE = 'SEARCH_ACTIONS:INSURERS_SEARCH_ITEM_ELEM_UPDATE';

var googleMapLoaded = exports.googleMapLoaded = function googleMapLoaded() {
    return {
        type: GOOGLE_MAP_LOADED
    };
};
var pageLoaded = exports.pageLoaded = function pageLoaded() {
    return {
        type: PAGE_LOADED
    };
};
var updateSearchBarHolderHeight = exports.updateSearchBarHolderHeight = function updateSearchBarHolderHeight(newHeight) {
    return {
        type: SEARCH_BAR_HOLDER_HEIGHT_UPDATE,
        payload: {
            searchBarHolderHeight: newHeight
        }
    };
};

var updateInsurersDropdownElem = exports.updateInsurersDropdownElem = function updateInsurersDropdownElem(newElem) {
    return {
        type: INSURERS_DROPDOWN_ELEM_UPDATE,
        payload: {
            insurersDropdownElem: newElem
        }
    };
};

var updateSearchItemDropdownElem = exports.updateSearchItemDropdownElem = function updateSearchItemDropdownElem(newElem) {
    return {
        type: INSURERS_SEARCH_ITEM_ELEM_UPDATE,
        payload: {
            searchItemDropdownElem: newElem
        }
    };
};


// WEBPACK FOOTER //
// ./components/search-page/lib/actions/page-actions.js